import React, { useEffect, useState, useCallback } from 'react';

// Dynamically import ALL images from both directories
function importAll(r) {
  return r.keys().map(r);
}

const mainImages = importAll(
  require.context('../assets/images', false, /\.(jpe?g|png|gif|svg|JPG|JPEG)$/i)
);

const whatsappImages = importAll(
  require.context('../assets/img whatsapp', false, /\.(jpe?g|png|gif|svg|JPG|JPEG)$/i)
);

// Combine and shuffle for variety
const allPhotos = [...whatsappImages, ...mainImages];

const IMAGES_PER_PAGE = 24;

const Gallery = () => {
  const [visibleCount, setVisibleCount] = useState(IMAGES_PER_PAGE);
  const [lightboxIndex, setLightboxIndex] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Close lightbox on Escape key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (lightboxIndex === null) return;
      if (e.key === 'Escape') setLightboxIndex(null);
      if (e.key === 'ArrowRight') setLightboxIndex(prev => (prev + 1) % allPhotos.length);
      if (e.key === 'ArrowLeft') setLightboxIndex(prev => (prev - 1 + allPhotos.length) % allPhotos.length);
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [lightboxIndex]);

  const handleLoadMore = useCallback(() => {
    setVisibleCount(prev => Math.min(prev + IMAGES_PER_PAGE, allPhotos.length));
  }, []);

  const displayedPhotos = allPhotos.slice(0, visibleCount);
  const hasMore = visibleCount < allPhotos.length;

  return (
    <>
      <section className="page-hero">
        <div className="container page-hero__content">
          <h1 className="page-hero__title">Event Gallery</h1>
          <div className="breadcrumb">
            <a href="/">Home</a> <span>/</span> Gallery
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="text-center">
            <div className="eyebrow" style={{justifyContent: 'center'}}>National School Tour & Events</div>
            <h2 className="section-title">LinkedIn Tour Cameroon Highlights</h2>
            <p className="section-body" style={{ maxWidth: 600, margin: '0 auto 16px' }}>
              Explore moments from our National School Tour and LinkedIn Local Cameroon events across the country.
            </p>
            <p className="gallery-count-badge">
              Showing {displayedPhotos.length} of {allPhotos.length} photos
            </p>
          </div>

          <div className="gallery-full-grid">
            {displayedPhotos.map((src, i) => (
              <div
                key={i}
                className="gallery-full-item"
                onClick={() => setLightboxIndex(i)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && setLightboxIndex(i)}
              >
                <img src={src} alt={`LLC Gallery ${i + 1}`} loading="lazy" />
                <div className="gallery-full-item__overlay">
                  <svg width="28" height="28" fill="none" stroke="white" strokeWidth="2" viewBox="0 0 24 24">
                    <circle cx="11" cy="11" r="8"></circle>
                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                    <line x1="11" y1="8" x2="11" y2="14"></line>
                    <line x1="8" y1="11" x2="14" y2="11"></line>
                  </svg>
                </div>
              </div>
            ))}
          </div>
          
          {hasMore && (
            <div className="text-center mt-12">
              <button className="btn btn-red" onClick={handleLoadMore}>
                Load More Photos ({allPhotos.length - visibleCount} remaining)
              </button>
            </div>
          )}

          {!hasMore && allPhotos.length > IMAGES_PER_PAGE && (
            <div className="text-center mt-12">
              <p style={{ color: 'var(--text-muted)', fontSize: 14 }}>✓ All {allPhotos.length} photos loaded</p>
            </div>
          )}
        </div>
      </section>

      {/* LIGHTBOX */}
      {lightboxIndex !== null && (
        <div className="gallery-lightbox" onClick={() => setLightboxIndex(null)}>
          <button className="gallery-lightbox__close" onClick={() => setLightboxIndex(null)} aria-label="Close">✕</button>
          <button
            className="gallery-lightbox__nav gallery-lightbox__nav--prev"
            onClick={(e) => { e.stopPropagation(); setLightboxIndex(prev => (prev - 1 + allPhotos.length) % allPhotos.length); }}
            aria-label="Previous"
          >
            ‹
          </button>
          <div className="gallery-lightbox__content" onClick={(e) => e.stopPropagation()}>
            <img src={allPhotos[lightboxIndex]} alt={`Gallery full ${lightboxIndex + 1}`} />
            <div className="gallery-lightbox__counter">{lightboxIndex + 1} / {allPhotos.length}</div>
          </div>
          <button
            className="gallery-lightbox__nav gallery-lightbox__nav--next"
            onClick={(e) => { e.stopPropagation(); setLightboxIndex(prev => (prev + 1) % allPhotos.length); }}
            aria-label="Next"
          >
            ›
          </button>
        </div>
      )}
    </>
  );
};

export default Gallery;
